// import ProductCarousel from "../../components/ProductCarousel/ProductCarousel";
import "./About.scss";
import InfoAvailable from "./components/InfoAvailable/InfoAvailable";
import ProductQuality from "./components/ProductQuality/ProductQuality";

const About = () => {
  return (
    <div className="about">
      <div className="expert">
        <h2>UNE EXPERTISE ACQUISE</h2>
        <p>
          Depuis 1986, la société SP Hygiène (anciennement Sacs Prestige)
          conçoit et commercialise une large gamme de produits d'hygiène et 
          d'entretien. <br /> Forts de notre expérience, nous pouvons
          aujourd'hui vous proposer, à travers nos 12 familles de produits, des
          solutions définies sur-mesure.
        </p>
      </div>
      <InfoAvailable />
      <ProductQuality />
      <div className="nitido-info">
        <div>
          <img src="/images/about/Nitido.png" alt="nitido" />
        </div>
        <p>
          Nitido est une marque dédiée à fournir aux professionnels du secteur
          de l'hygiène des produits de haute qualité, réguliers et respectueux
          de l'environnement. Nous nous engageons à offrir des solutions
          éco-responsables qui répondent aux besoins spécifiques de nos clients,
          tout en garantissant un excellent rapport qualité-prix. Chez Nitido,
          la durabilité et l'efficacité vont de pair pour assurer la
          satisfaction de nos partenaires professionnels.
        </p>
      </div>
      <div className="products-about">
        {/* <ProductCarousel products={products} buttonColor="#74b753" /> */}
      </div>
    </div>
  );
};

export default About;
